import { useAtomValue } from 'jotai';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Container } from '../../components/layout/ContainerFlex';
import { ScreenTitle } from '../../components/layout/ScreenTitle';
import LoadingIndicator from '../../components/LoadingIndicator';
import SidebarContainer, {
  SidebarContainerProps,
} from '../../containers/SidebarContainer';
import ActualityAggregatedStatsSubGroupPanel from '../panels/ActualityAggregatedStatsSubGroupPanel';
import { actualitySelectedId } from '../store/actuality.state';
import {
  actualitySelectedMenuIdAtom,
  actualitySelectedTabIdAtom,
} from '../store/actuality.ui.state';

const FeedEventsSidebar: React.FC = () => {
  const { t } = useTranslation('feed');
  return (
    <Container
      col
      data-component="FeedEventsSidebar"
      className="relative h-full overflow-hidden"
      hasOverflowY
    >
      <ScreenTitle
        isSticky
        title={t`Latest activities`}
        subtitle={t`Warehouse`}
      />

      <Suspense
        fallback={
          <Container col className="relative !p-2">
            <LoadingIndicator message={t`Loading Activities`} selfCenter />
          </Container>
        }
      >
        {/* ActualityAggregatedStatsSubGroupPanel supports independent sort vs display metrics:
            - Users can sort by any field (e.g., eventHour, agentId, etc.)
            - While displaying a different metric (e.g., eventsCount, analyzedDuration)
            - Change displayMetric prop to show different primary metric
        */}

        <Container
          data-component="FeedEventsSidebarContainer"
          col
          className="relative h-full flex-1 overflow-hidden"
        >
          <ActualityAggregatedStatsSubGroupPanel
            displayMode="events"
            displayMetric="eventsCount" // Can be: eventsCount, analyzedDuration, analyzedDistance, etc.
          />
        </Container>
        {/* <FeedPicklistPanel /> */}
      </Suspense>
    </Container>
  );
};

export default () => {
  const { t } = useTranslation('feed');
  const actualityId = useRecoilValue(actualitySelectedId);
  const selectedMenuId = useAtomValue(actualitySelectedMenuIdAtom(actualityId));
  const selectedTabId = useAtomValue(actualitySelectedTabIdAtom);
  const showEventsSidebar =
    selectedMenuId === 'feed-menu-activity' &&
    selectedTabId === 'tab-feed-process';
  // (selectedTabId === 'tab-feed-kpi' || selectedTabId === 'tab-feed-process');

  if (!showEventsSidebar) {
    return null;
  }

  const containerProps: SidebarContainerProps = {
    type: 'sidebar-feed-info-event',
    title: t`Activities`,
    size: 'xs',
  };

  return (
    <SidebarContainer {...containerProps}>
      <FeedEventsSidebar />
    </SidebarContainer>
  );
};
